module.exports = __webpack_public_path__ + "static/media/HelloVetLogo.82f1a1e2.png";